// - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
// decodeConvexDoc — reverse of the sync script's encodeKey() (#191).
//
// The Mongo->Convex sync (scripts/convex-sync/sync.mjs) encodes object field
// names that Convex rejects (non-ASCII like the FileMaker portal `»`, or a
// leading `$`) into a reversible ASCII token so they can be stored. The
// frontend reads several of those keys by their EXACT original name
// (e.g. schedule.context.js reads currentMaterial["KI_AQ » Materials::type"]),
// so we must decode them back before handing Convex data to the app.
//
// Pure + mutation-free: returns new objects/arrays, never touches the input.
// Round-trips losslessly with encodeKey().
// - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -

export function decodeKey(k) {
  let out = k.replace(/__U([0-9A-Fa-f]{4})__/g, (_, hex) =>
    String.fromCharCode(parseInt(hex, 16))
  );
  if (out.startsWith("__DLR__")) out = "$" + out.slice("__DLR__".length);
  return out;
}

export function decodeConvexDoc(value) {
  if (value === null || value === undefined) return value;
  if (Array.isArray(value)) return value.map(decodeConvexDoc);
  if (typeof value === "object") {
    const out = {};
    for (const [k, v] of Object.entries(value)) {
      out[decodeKey(k)] = decodeConvexDoc(v);
    }
    return out;
  }
  return value;
}

// Convenience: decode an array of docs (the common query-result shape).
export function decodeConvexList(list) {
  return Array.isArray(list) ? list.map(decodeConvexDoc) : list;
}
